// extracted by mini-css-extract-plugin
export default {"marketTabsWrapper":"styles_marketTabsWrapper__S0ppS","marketTab":"styles_marketTab__bxN22"};